export class DataValueEssay {

    value: string;

    constructor(value?: string | number) {
        this.value = value != null ? value.toString() : null;
    }

}
